(function(){
  if(window.lucide) lucide.createIcons();

  var amxs     = document.querySelector('.amxs');
  var heroWrap = document.querySelector('.amxs .shophero .wrap');
  var chipsEl  = document.getElementById('amxsChips');
  var chipsWrap= document.getElementById('amxsChipsWrap');
  var grid     = document.getElementById('amxsGrid');
  var cards, ghSig, ghLoved, empty;
  var curTab='benefit', curCat='all';
  var navigating = false;

  function bindGridRefs(){
    cards   = [].slice.call(grid.querySelectorAll('.pcard'));
    ghSig   = document.getElementById('amxsGhSig');
    ghLoved = document.getElementById('amxsGhLoved');
    empty   = document.getElementById('amxsEmpty');
  }
  bindGridRefs();

  function applyFilter(){
    var visible=0, best = curTab==='best';
    cards.forEach(function(c){
      var show=true;
      if(best){ show = c.dataset.badge==='sig' || c.dataset.badge==='loved'; }
      else if(curTab==='benefit' && curCat!=='all'){ show = (' '+c.dataset.cats+' ').indexOf(' '+curCat+' ')>-1; }
      c.classList.toggle('hidden',!show);
      if(show) visible++;
    });
    if(best){
      ghSig.classList.add('show'); ghLoved.classList.add('show');
      cards.forEach(function(c){
        if(c.dataset.badge==='sig'){c.style.order='1';}
        else if(c.dataset.badge==='loved'){c.style.order='3';}
      });
      ghSig.style.order='0'; ghLoved.style.order='2';
    } else {
      ghSig.classList.remove('show'); ghLoved.classList.remove('show');
      cards.forEach(function(c){ c.style.order=''; });
    }
    empty.style.display = visible===0 ? 'block':'none';
  }

  document.querySelectorAll('.amxs .tab').forEach(function(t){
    t.addEventListener('click', function(){
      document.querySelectorAll('.amxs .tab').forEach(function(x){x.classList.remove('on');});
      t.classList.add('on');
      curTab=t.dataset.tab;
      chipsWrap.classList.toggle('hide', curTab!=='benefit');
      if(curTab!=='benefit'){ curCat='all'; }
      applyFilter();
    });
  });

  /* Уся картка клікабельна → сторінка товару; додавання в кошик; «Сповістити».
     Делеговано на #amxsGrid (не на самі картки), щоб працювало й після
     AJAX-заміни вмісту сітки при навігації по чипах категорій. */
  grid.addEventListener('click', function(e){
    var add = e.target.closest('[data-add],.btn-add');
    if(add && add.dataset.variant){
      e.preventDefault();
      add.style.opacity=.7;
      fetch('/cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({id:add.dataset.variant,quantity:1})})
        .then(function(r){return r.json();})
        .then(function(item){
          if(window.amxOpenCartPopup){ window.amxOpenCartPopup(); }
          else { showToast(add.dataset.title+' додано до кошика'); if(window.amxRefreshCartBubble){ fetch('/cart.js').then(function(r){return r.json();}).then(function(c){window.amxRefreshCartBubble(c.item_count);}); } }
          try {
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({ event:'add_to_cart', ecommerce:{ currency:(item&&item.currency)||'UAH', value:((item&&item.final_price)||0)/100, items:[{ item_name: add.dataset.title, quantity:1, price:((item&&item.final_price)||0)/100 }] } });
          } catch(e){}
        })
        .catch(function(){ window.location.href='/cart'; })
        .finally(function(){ add.style.opacity=''; });
      return;
    }
    var nt = e.target.closest('[data-notify]');
    if(nt){ openNotify(nt.dataset.notify); return; }
    var card = e.target.closest('.pcard');
    if(card && card.dataset.handle && !e.target.closest('a, button, [data-variant], [data-notify]')){
      window.location.href = '/products/' + card.dataset.handle;
    }
  });

  /* Чипи «За потребою» — реальні посилання на колекції, але переходимо по AJAX
     (fetch + заміна вмісту секції), щоб не перезавантажувати сторінку. */
  function swapFromHtml(html){
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var newChips = doc.getElementById('amxsChips');
    var newGrid  = doc.getElementById('amxsGrid');
    var newHero  = doc.querySelector('.amxs .shophero .wrap');
    if(newChips) chipsEl.innerHTML = newChips.innerHTML;
    if(newGrid)  grid.innerHTML = newGrid.innerHTML;
    if(newHero && heroWrap) heroWrap.innerHTML = newHero.innerHTML;
    bindGridRefs();
    curTab = 'benefit'; curCat = 'all';
    chipsWrap.classList.remove('hide');
    applyFilter();
    if(window.lucide) lucide.createIcons();

    /* AJAX-перехід не перезавантажує <head> — синхронізуємо title/meta description/
       canonical вручну, інакше вони лишаються від першої завантаженої сторінки. */
    if(doc.title) document.title = doc.title;
    var newDesc = doc.querySelector('meta[name="description"]');
    var curDesc = document.querySelector('meta[name="description"]');
    if(newDesc){
      if(!curDesc){ curDesc = document.createElement('meta'); curDesc.setAttribute('name','description'); document.head.appendChild(curDesc); }
      curDesc.setAttribute('content', newDesc.getAttribute('content') || '');
    } else if(curDesc){
      curDesc.remove();
    }
    var newCanon = doc.querySelector('link[rel="canonical"]');
    var curCanon = document.querySelector('link[rel="canonical"]');
    if(newCanon && curCanon) curCanon.setAttribute('href', newCanon.getAttribute('href') || '');
  }

  function navigate(url, push){
    if(navigating) return;
    navigating = true;
    amxs.classList.add('amxs-loading');
    /* Повна сторінка (без section_id), щоб мати <head> для оновлення title/meta/canonical. */
    fetch(url)
      .then(function(r){ if(!r.ok) throw new Error('nav failed'); return r.text(); })
      .then(function(html){
        swapFromHtml(html);
        if(push) history.pushState({ amxsNav: true }, '', url);
        var catalogEl = document.querySelector('.amxs .catalog');
        if(catalogEl) window.scrollTo({ top: catalogEl.offsetTop - 20, behavior: 'smooth' });
      })
      .catch(function(){ window.location.href = url; })
      .finally(function(){ navigating = false; amxs.classList.remove('amxs-loading'); });
  }

  chipsEl.addEventListener('click', function(e){
    var c = e.target.closest('.chip'); if(!c) return;
    if(e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    navigate(c.getAttribute('href'), true);
  });

  window.addEventListener('popstate', function(){
    navigate(window.location.pathname + window.location.search, false);
  });

  applyFilter();

  /* cart + toast */
  var toast=document.getElementById('amxsToast'), toastMsg=document.getElementById('amxsToastMsg'), tHide;
  function showToast(m){ toastMsg.textContent=m; toast.classList.add('show'); clearTimeout(tHide); tHide=setTimeout(function(){toast.classList.remove('show');},2200); }

  /* notify modal */
  var overlay=document.getElementById('amxsOverlay'), formV=document.getElementById('amxsForm'), okV=document.getElementById('amxsOk');
  var email=document.getElementById('amxsEmail'), err=document.getElementById('amxsErr');
  function openNotify(name){
    document.getElementById('amxsProd').textContent=name||'цей продукт';
    document.getElementById('amxsProdOk').textContent=name||'продукт';
    formV.style.display='block'; okV.classList.remove('show'); email.value=''; err.classList.remove('show');
    overlay.classList.add('show'); setTimeout(function(){email.focus();},60);
  }
  function closeNotify(){ overlay.classList.remove('show'); }
  document.getElementById('amxsClose').onclick=closeNotify;
  document.getElementById('amxsDone').onclick=closeNotify;
  overlay.addEventListener('click', function(e){ if(e.target===overlay) closeNotify(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && overlay.classList.contains('show')) closeNotify(); });
  document.getElementById('amxsSubmit').onclick=function(){
    var v=email.value.trim();
    if(!/^[^@\s]+@[^@\s]+\.[^@\s]+$/.test(v)){ err.classList.add('show'); return; }
    err.classList.remove('show'); formV.style.display='none'; okV.classList.add('show');
  };
  email.addEventListener('keydown', function(e){ if(e.key==='Enter') document.getElementById('amxsSubmit').click(); });
})();
